import { useReducer } from "react";

const initialInputState = {
  value: "",
  isTouched: false,
  isFocus: false,
};

// state : previous state snapshot
// action: is the action you dispatched somewhere in your code
// Both are passed in automatically by React.
// You have to return a new state snapshot.
// action.value is afkomstig uit valueChangeHandler
const inputStateReducer = (state, action) => {
  console.log("state.value  : " + state.value);
  console.log("action.waarde: " + action.waarde);

  if (action.type === "INPUT") {
    return { isTouched: state.isTouched, value: action.waarde, isFocus: false };
  }
  if (action.type === "BLUR") {
    return { isTouched: true, value: state.value, isFocus: false }; // state.value : existing value
  }
  if (action.type === "RESET") {
    return { isTouched: false, value: "", isFocus: false };
  }
  if (action.type === "FOCUS") {
    return { isTouched: false, value: state.value, isFocus: true }; // state.value : existing value
  }
  return inputStateReducer;
};

// validateValue is functie die bij de aanrope wordt meegegeven
// vanuit aanroepende component (niet leeg, bevat @, langer dan 8 posities)
const useInput = (validateValue) => {
  console.log("Start useInput");
  //console.log(inputStateReducer);
  //console.log(initialInputState);

  // inputStateReducer : our input state reducer function
  // initialInputState : our initial state
  // useReducer returns an array with exactly two elements.
  // The first element is always the state managed by the reducer.
  // The second element is always a dispatched function which allows you to dispatch actions against that reducer.
  const [inputState, dispatch] = useReducer(
    inputStateReducer,
    initialInputState
  );

  console.log(inputState);
  //console.log(dispatch);

  //console.log(validateValue);
  console.log(inputState.value);
  const valueIsValid = validateValue(inputState.value);
  const hasError = !valueIsValid && inputState.isTouched;

  // dispatch an action against our reducer. It is often an object with a type property which identifies the action.
  // It can also carry a payload. Here we will add a value property to this object.
  const valueChangeHandler = (event) => {
    console.log(event);
    dispatch({ type: "INPUT", waarde: event.target.value });
  };

  const inputBlurHandler = () => {
    dispatch({ type: "BLUR" });
  };

  const reset = () => {
    dispatch({ type: "RESET" });
  };

  const inputFocusHandler = () => {
    dispatch({ type: "FOCUS" });
  };

  console.log("End useInput");

  return {
    value: inputState.value,
    isValid: valueIsValid,
    hasError,
    valueChangeHandler,
    inputBlurHandler,
    reset,
    inputFocusHandler,
    isFocus: inputState.isFocus,
  };
};

export default useInput;
